import React from 'react';
import { Grid, Button, FormLabel } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { number, obj, func, bool, shape } from 'prop-types';

import { FormTextField } from '../../../../components';
import { getI18n } from '../../../../utils/intl';

export const FilterByName = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormTextField
      {...props}
      id="app-apis-filter-by-name"
      data-apim-test="app-apis-filter-by-name"
    />
  </Grid>
);
export const FilterBySeparator = (props) => (
  <Grid item md={3} sm={3} xs={12} className={props.fieldContainerClass} />
);

FilterBySeparator.propTypes = {
  fieldContainerClass: shape({}),
};
export const HeaderActionButtons = (props) => {
  const {
    classes = {},
    bulkActionsItemsCount,
    onAssign,
    onUnassign,
    disableAdd,
    disableRemove,
  } = props;

  const id = 'app-api-assignment'
  const intl = getI18n(useIntl());

  return (
    <div className={classes.actionsFieldContainer}>
      <FormLabel className={ classes.actionsLabel }>
        {intl.getI18nMessage('label.application.details.api.actions.count', { count: bulkActionsItemsCount })}
      </FormLabel>
      <Grid
        item md={12} sm={12} xs={12}
        className={classes.headerButtons}
      >
        <Button
          variant="contained" color="secondary"
          className={classes.addButton}
          id={`${id}-add`} data-apim-test={`${id}-add`} data-layer7-test={`${id}-add`}
          onClick={onAssign}
          disabled={disableAdd}
        >
          {intl.getI18nMessage('label.application.details.apis.actions.assign')}
        </Button>
        <Button
          variant="contained" color="secondary"
          className={classes.removeButton}
          id={`${id}-remove`} data-apim-test={`${id}-remove`} data-layer7-test={`${id}-remove`}
          onClick={onUnassign}
          disabled={disableRemove}
        >
          {intl.getI18nMessage('label.application.details.apis.actions.unassign')}
        </Button>
      </Grid>
    </div>
  );
}

HeaderActionButtons.propTypes = {
  classes: obj,
  bulkActionsItemsCount: number,
  onAssign: func,
  onUnassign: func,
  disableAdd: bool,
  disableRemove: bool,
};
